export enum TipoOperacion {
    TEMPORIZADOR = 0,
    HOMEVOTACION = 1,
}

export enum ESTADOS {
    ESTADO_PERFIL = 1,
    SITIO_WEB_ESTADO = 2,
    ROL_USUARIO = 3
}

export enum ESTADOS_PERFIL {
    PENDIENTE = 1,
    EN_APROBACION = 2,
    PUBLICADO = 3,
    DENEGADO = 4
}

export enum ESTADOS_SITIO {
    CUENTA_REGRESIVA = 5,
    NOMINAR_VOTAR = 6,
    FINALISTAS = 7,
    GANADORES = 8
}